import { useCallback } from "react"
import { useController, useFormContext } from "react-hook-form"
import type { CheckboxProps } from "./Checkbox"
import { Checkbox } from "./Checkbox"

export interface CheckboxFieldProps extends Omit<CheckboxProps, "name" | "onChange" | "children"> {
	isNew?: boolean
	label: string
	name: string
	onChange?: (value: boolean, name: string, type: "select" | "deselect") => void
}

export const CheckboxField = (props: CheckboxFieldProps) => {
	const { isNew, label, name, onChange, ...rest } = props
	const { control } = useFormContext()

	const {
		field: { onChange: fieldOnChange, value },
		fieldState: { error },
	} = useController({
		control,
		name,
		shouldUnregister: true,
	})

	const handleChange = useCallback(
		(newValue: boolean) => {
			fieldOnChange(newValue)
			onChange?.(newValue, name, newValue ? "select" : "deselect")
		},
		[fieldOnChange, onChange, name],
	)

	return (
		<Checkbox
			isNew={isNew}
			data-testid={`checkbox-${name}`}
			name={name}
			state={error ? "error" : undefined}
			{...rest}
			onChange={handleChange}
			checked={value}
		>
			{label}
		</Checkbox>
	)
}
